import type { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const isRenderFunction = <T extends Function>(arg: ReactNode | T): arg is T => typeof arg === 'function';
